<template>
  <div class="margins">
  <svg width="24" height="19" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 7.125V2.375L12 7.125V2.375L6 7.125V0H0V19H24V2.375L18 7.125ZM8.4 15.4375H6V11.875H8.4V15.4375ZM14.4 15.4375H12V11.875H14.4V15.4375ZM20.4 15.4375H18V11.875H20.4V15.4375Z" fill="currentColor"/>
  </svg>
</div>
</template>

<script>
export default {
  name: "EffluentsGranting"
}
</script>

<style scoped>

.margins svg {
  margin-top: 2.7px;
  margin-left: 0.7px;
}

</style>
